import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import CAppComponent from "./capp-component";
import {Link} from "react-router-dom";
import Notifications from "../../../common/js/components/content-editor/gallery/notifications";
import ci from '../../../common/js/common-images';

class Unauthorized extends CAppComponent {

    render() {
        const { auth, intl } = this.props;
        const { user } = auth;

        return (
            <div className="main-content-menuless bg-gray">
                 <div className="bg-white text-left">
                        <div className="container pt-4 pb-4">
                            <img src={ci.gasnet_logo_green} width='140' height='50'/>
                        </div>
                    </div>
                <div className='container pt-5 pb-5'>
                    <Notifications/>
                    <hr className='gasnet-divider'/>
                    <h1><FormattedMessage id={'app.auth.unauthorized.title'}/></h1>
                    <p><strong><FormattedMessage id={'app.auth.unauthorized.message'}/></strong></p>
                    <p>
                        <Link to={'/sign-in'} className='btn btn-primary'><FormattedMessage id='app.auth.sign_in.title'/></Link>
                    </p>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state,ownProps) {
    return {
        auth: state.auth
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, matchDispatchToProps)(Unauthorized));
